import type { IHomeLoanCompareProductCommissionsPayable } from './HomeLoanCompareProductCommissionsPayable.interface';

export default class HomeLoanCompareProductCommissionsPayable
  implements IHomeLoanCompareProductCommissionsPayable {
  upfront: number;
  trail: number;

  static build = (data: IHomeLoanCompareProductCommissionsPayable) =>
    new HomeLoanCompareProductCommissionsPayable(data);

  static blank = () => new HomeLoanCompareProductCommissionsPayable();

  /**
   * Constructor
   * @param {IHomeLoanCompareProductCommissionsPayable} data
   */
  constructor(data?: IHomeLoanCompareProductCommissionsPayable) {
    this.upfront = parseFloat(data?.upfront || 0);
    this.trail = parseFloat(data?.trail || 0);
  }
}
